import React, { useEffect, useRef, useState } from 'react'
import { Col, Row, Table, Modal, ModalBody, ModalHeader, Badge } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import Image from '../../components/Image'
import dummyRoundedImage from "../../assets/images/dummy-rounded-image.png"
import { getTestCallLogs } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { formatTimeFromSeconds, formatDate, formatTime } from '../../helper/format';
import { EmptyRow } from '../../components/EmptyState';

const ListTestCalls = () => {
  const [loading, setLoading] = useState(false)
  const [testCallLogs, setTestCallLogs] = useState([])
  const [selectedLog, setSelectedLog] = useState({})
  const [viewModal, setViewModal] = useState(false);
  const [mode, setMode] = useState(false);
  const keywordRef = useRef("");

  useEffect(() => {
    fetchTestCallLogs();
  }, [])

  const fetchTestCallLogs = (keyword = "") => {
    setLoading(true)
    setTestCallLogs([])
    getTestCallLogs({ ...(keyword && keyword.length && { search: keyword }) }).then((data) => {
      if (data.data) {
        setTestCallLogs(data.data ? data.data : [])
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    fetchTestCallLogs(keywordRef.current.value)
  }


  const handleViewModal = (mode, log) => {
    setSelectedLog(log)
    setMode(mode)
    setViewModal(true)
  }

  return (
    <div className="content-page">
      <div className="content">

        <div className="container-fluid">

          <div className="py-3 py-3 row">
            <div className="col-12">

              <Row className="my-2 align-items-center">
                <Col md={8}>
                  <h4>Test Calls List</h4>
                  <p className='text-muted fs-12'>Review the test sessions you've run against your agents</p>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={5}>
                  <div className='d-flex'>
                    <div className="position-relative w-70 me-2">
                      <input type="text" className="form-control p-2 ps-4" placeholder="Search..." ref={keywordRef} />
                      <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2"></i>
                    </div>
                    <button type='button' disabled={loading} onClick={(e) => { searchByKeyword(e) }} className="font-normal py-2 px-4 rounded fs-14 linear-gradient-btn border-0">Search</button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Table hover responsive className='border-rounded custom-listing-tables'>
                    <thead>
                      <tr>
                        <th>Agent</th>
                        <th>Test Date</th>
                        <th>Call Length</th>
                        <th>Converted</th>
                        <th>Analysis</th>
                        <th>Summary</th>
                        <th>Transcript</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(10)].map((a, i) => {
                            return <tr key={i}>
                              <td className="fs-12"><div className='d-flex align-items-center'><Skeleton height={40} width={40} circle={true} className='me-2' /><Skeleton height={12} width={90} /></div></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={80} /></td>
                              <td className="fs-12"><Skeleton height={12} width={90} /></td>
                              <td className="fs-12"><Skeleton height={12} width={90} /></td>
                            </tr>
                          }) :
                          testCallLogs.length === 0 ?
                            <EmptyRow colSpan={7} icon="ri-flask-line" title="No test calls yet" body="Test an agent to see how it handles a live conversation." /> :
                            testCallLogs.map((log, i) => {
                              const callSuccessful = log.analysis?.call_successful;
                              return <tr key={i}>
                                <td className="fs-12 fw-500"><div className='d-flex align-items-center'><Image src={dummyRoundedImage} alt="Event" className='rounded-circle me-2' height='40px' width='40px' objectFit='cover' /><p className='m-0'>{log.agentId ? log.agentId.name : "N/A"} <span className='d-block text-muted fs-12 text-capitalize'>{log.agentId ? log.agentId.type : "N/A"}</span></p></div></td>
                                <td className="fs-12 fw-500 text-nowrap">
                                  {formatDate(log.createdAt)}
                                  <span className="d-block text-muted">{formatTime(log.createdAt)}</span>
                                </td>
                                <td className="fs-12 fw-500 text-nowrap">{log.callLength ? formatTimeFromSeconds(log.callLength) : "N/A"}</td>
                                <td className="fs-12 fw-500">{callSuccessful ? (callSuccessful === "success" ? <Badge color='badge-success badge-soft-success fs-12'>Yes</Badge> : <Badge color='badge-danger badge-soft-danger fs-12'>No</Badge>) : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.analysis ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('analysis', log) }}>View Analysis</p> : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.summary ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('summary', log) }}>View Summary</p> : "N/A"}</td>
                                <td className="fs-12 fw-500">{log.transcript ? <p className='text-decoration-underline m-0 cursor-pointer' onClick={() => { handleViewModal('transcript', log) }}>View Transcript</p> : "N/A"}</td>
                              </tr>
                            })
                      }
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
            <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='lg'>
              <ModalHeader toggle={() => { setViewModal(false) }}>
                <small>{mode === 'summary' ? "Summary" : mode === 'transcript' ? "Transcript" : "Analysis"}</small>
              </ModalHeader>
              <ModalBody>
                {
                  mode === 'analysis' ?
                    <Row>
                      <Col md={12} className='mb-4'>
                        {
                          selectedLog.analysis?.transcript_summary ?
                            <p className='mb-3'><strong>Transcript Summary: </strong>{selectedLog.analysis.transcript_summary}</p> : null
                        }
                        {
                          selectedLog.analysis?.data_collection_results && Object.keys(selectedLog.analysis.data_collection_results).length ?
                            Object.entries(selectedLog.analysis.data_collection_results).map(([key, item], idx) => (
                              <div key={idx} className='mb-3 p-2 border rounded'>
                                <p className='fw-600 mb-1'>{item?.data_collection_id || key}</p>
                                <p className='mb-1'><strong>Result: </strong>{String(item?.value)}</p>
                                {item?.rationale ? <p className='mb-0 text-muted fs-13'><strong>Rationale: </strong>{item.rationale}</p> : null}
                              </div>
                            )) :
                            <p className='text-muted m-0'>No data collection results available</p>
                        }
                      </Col>
                    </Row> :
                    <Row>
                      <Col md={12} className='mb-4'>
                        <textarea disabled={true} value={mode === 'summary' ? selectedLog.summary : selectedLog.transcript} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                      </Col>
                    </Row>
                }
                <Row className="text-center mt-3">
                  <Col>
                    <button className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListTestCalls
